import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import './EventPoster.css'

import {
  EventContentContainer,
  EventImageContainer,
  Title,
  Description,
  PageSection,
  Container,
  Image,
  Clearfix,
} from './EventPoster.css.js';

const EventPoster = ({ config, content }) => {
  const { backgroundColor, titleColor, sectionVerticalPaddingSize } = config;
  const { title, description, eventImage } = content;

  const renderEventImage = () => (
    <Image
      src={eventImage} alt=""
    />
  );

  return (
    <PageSection
      backgroundColor={backgroundColor}
      titleColor={titleColor}
    >
      <Container
        isCenteredSection={true}
        removeGutters={true}
        sectionVerticalPaddingSize={sectionVerticalPaddingSize}
      >
          <EventContentContainer>
            {title && (
              <Title>{title}</Title>
            )}

            {description && (
              <Description>
                <ReactMarkdown
                  escapeHtml={false}
                >
                  {description}
                </ReactMarkdown>
              </Description>
            )}
          </EventContentContainer>

          <EventImageContainer>
            {renderEventImage()}
          </EventImageContainer>
      </Container>

      <Clearfix />
    </PageSection>
  );
}

EventPoster.propTypes = {
  config: PropTypes.shape({
    backgroundColor: PropTypes.string,
    titleColor: PropTypes.string,
    sectionVerticalPaddingSize: PropTypes.oneOf([`x-large`, `large`, `medium`, `small`]),
  }),
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    eventImage: PropTypes.string.isRequired,
  }),
}

export default EventPoster;
